import React from "react";

export default function SQL_Quiz() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_Quiz</h1>
      <p>This is the SQL_Quiz component generated from the SQL JSON.</p>
    </div>
  );
}
